export const timeMachineDetailFullUrl = '/detail/:chain/:exchange/:id/:name';